import CheckBoxIcon from "@mui/icons-material/CheckBox"
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank"
import { Checkbox, TextField } from "@mui/material"
import Autocomplete from "@mui/material/Autocomplete"
import CircularProgress from "@mui/material/CircularProgress"
import { UseGetAreas } from "Hooks/areas/getAreas"
import { useCallback } from "react"
import { Fragment, useEffect, useMemo, useState } from "react"
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />
/**
 *
 * @param {*} props
 * @param {boolean} props.manager
 * @param {number} props.value
 * @param {boolean}props.disabled
 * @param {boolean}props.fullWidth
 * @param {string}props.minWidth
 * @returns
 */
const InputSelectAreas = (props) => {
	const { areas, loading: loadingGet } = UseGetAreas(!props?.data, {
		manager: props?.manager,
	})
	const data = useMemo(() => props.data ?? areas, [areas, props.data])
	const loading = useMemo(() => {
		if (props?.data) return props?.loading ?? false

		return loadingGet
	}, [loadingGet, props?.data, props?.loading])
	const [selectedDepartamento, setSelectedDepartamento] = useState(null)

	useEffect(() => {
		data.forEach((element) => {
			if (props.value === element.id) setSelectedDepartamento(element)
		})
	}, [data, props.value])

	return (
		<Autocomplete
			fullWidth={props.fullWidth}
			style={{ minWidth: props.minWidth }}
			disabled={props.disabled || loading}
			value={selectedDepartamento} // El valor seleccionado
			onChange={(event, newValue) => {
				if (props.setValue) props.setValue(newValue.id)
				setSelectedDepartamento(newValue)
			}}
			options={data}
			loading={loading}
			getOptionLabel={(option) => option.description}
			renderInput={(params) => (
				<TextField
					{...params}
					label="Departamento"
					slotProps={{
						input: {
							...params.InputProps,
							endAdornment: (
								<Fragment>
									{loading ? (
										<CircularProgress color="inherit" size={20} />
									) : null}
									{params.InputProps.endAdornment}
								</Fragment>
							),
						},
					}}
				/>
			)}
		/>
	)
}

export default InputSelectAreas

export const InputSelectAreasMultiple = (props) => {
	const { areas, loading: loadingGet } = UseGetAreas(!props?.data, {
		manager: props?.manager,
	})
	const data = useMemo(() => props.data ?? areas, [areas, props.data])
	const loading = useMemo(() => {
		if (props?.data) return props?.loading ?? false

		return loadingGet
	}, [loadingGet, props?.data, props?.loading])
	const [selectedDepartamento, setSelectedDepartamento] = useState([])

	const onChange = useCallback(
		(event, newValue) => {
			setSelectedDepartamento(newValue)
			let ids = null
			if (Array.isArray(newValue) && props?.setValue) {
				ids = newValue.map((item) => item.id)
				props?.setValue(ids)
			}
		},
		[props]
	)

	useEffect(() => {
		if (!props?.value) return

		const selected = []

		data.forEach((element) => {
			if (props.value.includes(element.id)) selected.push(element)
		})
		setSelectedDepartamento(selected)
	}, [data, props.value])

	return (
		<Autocomplete
			multiple
			disableCloseOnSelect
			fullWidth={props.fullWidth}
			style={{ minWidth: props.minWidth }}
			disabled={props.disabled || loading}
			{...{
				onChange,
				value: selectedDepartamento, // El valor seleccionado
			}}
			options={data ?? []}
			loading={loading}
			getOptionLabel={(option) => option.description}
			isOptionEqualToValue={(option, value) => option.id === value.id}
			renderOption={(props, option, { selected }) => {
				const { key, ...optionProps } = props
				return (
					<li key={key} {...optionProps}>
						<Checkbox
							icon={icon}
							checkedIcon={checkedIcon}
							style={{ marginRight: 8 }}
							checked={selected}
						/>
						{option.description}
					</li>
				)
			}}
			renderInput={(params) => (
				<TextField
					{...params}
					label="Departamento"
					slotProps={{
						input: {
							...params.InputProps,
							endAdornment: (
								<Fragment>
									{loading ? (
										<CircularProgress color="inherit" size={20} />
									) : null}
									{params.InputProps.endAdornment}
								</Fragment>
							),
						},
					}}
				/>
			)}
		/>
	)
}
